import React from "react";
import { Link } from "react-router-dom";

export const ItemsBloqueHome = ({
    className,
    logo,
    texto,
    href,
    to,
    action,
    logoStyle
}) => {
    return (
        <>
            {href ? (
                <a
                    target="_blank"
                    className="btn-bloqueHome mb-half mb-xl-0 d-flex justify-content-center"
                    href={href}
                >
                    <button className=" row ">
                        {logo && (
                            <div className="col-3">
                                <img
                                    className="logo"
                                    src={logo}
                                    style={logoStyle}
                                />
                            </div>
                        )}
                        <div className="col-9 text">
                            <p>{texto}</p>
                        </div>
                    </button>
                </a>
            ) : to ? (
                <Link
                    className="btn-bloqueHome mb-half mb-xl-0 d-flex justify-content-center"
                    to={to}
                >
                    <button className=" row">
                        {logo && (
                            <div className="col-3">
                                <img
                                    className="logo"
                                    src={logo}
                                    style={logoStyle}
                                />
                            </div>
                        )}
                        <div className="col-9 d-flex text">
                            <p>{texto}</p>
                        </div>
                    </button>
                </Link>
            ) : (
                <div className="btn-bloqueHome mb-half mb-xl-0 d-flex justify-content-center">
                    <button className="row" onClick={action}>
                        {logo && (
                            <div className="col-3">
                                <img
                                    className="logo"
                                    src={logo}
                                    style={logoStyle}
                                />
                            </div>
                        )}
                        <div className="col-9 d-flex text">
                            <p>{texto}</p>
                        </div>
                    </button>
                </div>
            )}
        </>
    );
};
